var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTaskAnimalBanishment = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M12 2a10 10 0 1 0 10 10A10.013 10.013 0 0 0 12 2M4.21 12A7.787 7.787 0 0 1 16.67 5.767L5.767 16.668A7.75 7.75 0 0 1 4.209 12M12 19.79a7.75 7.75 0 0 1-4.67-1.557L18.232 7.332A7.786 7.786 0 0 1 12 19.79"
})));
export default SvgTaskAnimalBanishment;